import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import {
  TextField, InputAdornment,
  Container,
  Card,
  Box,
  FormControl, Grid,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PostRequest from "../../components/apiConnections/postRequest.js";
import { useSnackbar } from "notistack";
import moment from "moment";
import "../../pages/css/Vendors.css";
import "../../pages/css/newVendor.css";
import NewHeader from "../../layouts/dashboard/header/NewHeader.js";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { CustomNoRowsOverlay } from "../Assessment.js"
import SearchIcon from '../../assets/searchico.svg';
import CustomPagination from "../../components/common/customPagination.jsx";
// ----------------------------------------------------------------------

export default function VendorAssessmentsPage() {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const [showLoader, setshowLoader] = useState(false);
  const [complianceData, setComplianceData] = useState({});
  const userEmail = window.localStorage.getItem("userEmail");
  const [rowCount, setRowCount] = useState(0);
  const [filterSearch, setFilterSearch] = useState(null)
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    getAssessmentByVendor(paginationModel.page + 1, paginationModel.pageSize);
  }, [paginationModel]);

  useEffect(() => {
    let time = setTimeout(() => {
      if (filterSearch !== null) getAssessmentByVendor(1, paginationModel.pageSize)
    }, 500)
    return () => clearTimeout(time)
  }, [filterSearch])

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleRowClick = (params) => {
    navigate(`../questionnaireSubmitted/${params.row._id}`, { state: { Data: params.row, panel: 'vendor' } })
  };
  const getAssessmentByVendor = async (page, pageSize) => {
    setshowLoader(true);
    try {
      const assessmentPayload = {
        email: userEmail,
      };
      const refreshToken = await PostRequest(
        `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_REFRESH_TOKEN}`,
        {},
        {},
        "refreshToken"
      );
      if (refreshToken) {
        PostRequest(
          `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_GET_ASSESSMENT_BY_VENDOR}?page=${page
          }&pageSize=${pageSize}&search=${filterSearch || ""}`,
          assessmentPayload
        )
          .then((resAssessment) => {
            setComplianceData(resAssessment?.data?.data?.data);
            setRowCount(resAssessment?.data?.data?.totalAssessment || 0);
            setshowLoader(false);
          })
          .catch((err) => {
            // no data
            enqueueSnackbar("Assessment not find", { variant: "error" });
            setshowLoader(false);
            return false;
          });
      }
    } catch (error) {
      // no data
      enqueueSnackbar("Requested Url not find", { variant: "error" });
      setshowLoader(false);
      return false;
    }
  };
  const filteredRows =
    (!complianceData || !complianceData.length) ? [] :
      complianceData
        ?.map((val, i) => ({
          ...val,
          id: i + 1 + (paginationModel?.page * paginationModel?.pageSize),
        }));
  const columns = [
    {
      field: "id",
      headerName: "#",
      flex: 0.5,
      sortable: false,
      className: "serial-number",
      disableColumnMenu: true,
    },
    {
      field: "set",
      headerName: "Set Name",
      flex: 1.5,
      disableColumnMenu: true,
    },
    {
      field: "companyName",
      headerName: "Company Name",
      flex: 1.1,
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      flex: 1,
      disableColumnMenu: true,
      valueFormatter: (params) => {
        return moment.unix(params.value).format("DD/MM/YYYY");
      }
    },
    {
      field: "deadline",
      headerName: "Deadline",
      flex: 1,
      disableColumnMenu: true,
      valueFormatter: (params) => {
        return moment.unix(params.value).format("DD/MM/YYYY");
      }
    },
    {
      field: "score",
      headerName: "Score",
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'nowrap' }}>
          <p style={{ margin: 0 }}>{params.row.score}/100</p>
        </div>
      ),
    },
    {
      field: "firstName",
      headerName: "Created By",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "assessmentStatus",
      headerName: "Status",
      flex: 1,
      disableColumnMenu: true,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => {
        let status = params.value;
        return (status !== "Extended Deadline" ?
          <span className={`statusClass ${status}`}>{status}</span>
          :
          <span className={`statusClass Extended_Deadline`}>{status}</span>
        );
      },
    },

  ];

  const handleSearch = (event) => {
    setFilterSearch(event.target.value)
  };

  return (
    <>
      <Helmet>
        <title> Dashboard | Genesis Platform</title>
      </Helmet>
      <Container maxWidth={false} className="max-w-left">
        <NewHeader titleName="Assessment" />
        <Grid container spacing={3} className="ipad-space">
          <Grid item xs={12} md={12} lg={12}>
            <Card className="full-coverdesign margin-questionnaire">
              <div className="cover-table">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                    top: "4px",
                    left: "5px",

                  }}
                >
                  <FormControl
                    className="select-entries"
                    variant="outlined"
                    size="small"
                  >
                    <Select
                      value={paginationModel.pageSize}
                      onChange={(e) => handlePaginationModelChange({ page: 0, pageSize: e.target.value })}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                    </Select>
                  </FormControl>
                  <span className="entries-per">entries per page</span>{" "}
                </div>
                <div className="top-0issues">
                  <Box
                    sx={{
                      width: "100%",
                      "& .MuiDataGrid-columnHeaders": {
                        minWidth: "100%",
                        overflowX: "hidden",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        minWidth: "100%",
                        overflowX: "auto",
                      },
                    }}
                  >

                    <TextField
                      variant="outlined"
                      placeholder="Search…"
                      value={filterSearch}
                      onChange={handleSearch}
                      className='searh-text-field topsearch-top-0'
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img src={SearchIcon} alt='icon' />
                          </InputAdornment>
                        ),
                      }}
                    />

                    <DataGrid
                      loading={showLoader}
                      rows={filteredRows}
                      columns={columns}
                      rowHeight={70}
                      onPaginationModelChange={handlePaginationModelChange}
                      paginationModel={paginationModel}
                      rowCount={rowCount}
                      pageSizeOptions={[5, 10, 25]}
                      slots={{
                        toolbar: GridToolbar,
                        noRowsOverlay: CustomNoRowsOverlay,
                        pagination: CustomPagination,
                      }}
                      slotProps={{
                        pagination: {
                          paginationModel,
                          onPaginationModelChange: handlePaginationModelChange,
                          rowCount
                        },
                      }}
                      disableRowSelectionOnClick
                      disableColumnFilter
                      disableColumnSelector
                      disableDensitySelector
                      disableColumnMenu
                      paginationMode="server"
                      disableSelectionOnClick
                      autoHeight
                      className="datagrid-table click-hover-datagrid"
                      sx={{
                        "& .MuiDataGrid-columnHeaders": {
                          minWidth: "100%", // Column headers take up full width
                        },
                        "& .MuiDataGrid-virtualScroller": {
                          minWidth: "100%", // Rows take up full width
                        },
                      }}
                      onRowClick={handleRowClick}
                    />
                  </Box>
                </div>
              </div>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
